// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#lookup-popup-section .popup-details {\n  padding: 20px 20px 0 20px;\n  position: relative;\n}\n#lookup-popup-section .popup-details:after {\n  content: \"\";\n  position: absolute;\n  bottom: 5px;\n  left: 0;\n  right: 0;\n  background: rgba(0, 0, 0, 0.1);\n  height: 1px;\n}\n#lookup-popup-section .el-table {\n  width: 99.5%;\n}", ""]);
// Exports
module.exports = exports;
